import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import {HelioviewerMissionInfoBox} from './../helioviewermodal/helioviewermodalmissioninfobox';

/**
 * Modal for displaying helioviewer image.
 *
 * @param props.wavelength - String The wavelength of interest.
 * @param props.type - StringThe type used for image processing or retrieval.
 * @param props.data - The data associated with the image or processing.
 * @param props.loading - Indicates whether data is currently being loaded.
 * @param props.startTime - The starting time for the image or data processing.
 * @param props.onStartTimeChange - Callback function to handle changes in the start time.
 * @param props.imageTimestamp - The timestamp when the image was captured or processed.
 * @param props.missions - String of missions related to the image or data.
 * @param props.instruments - List of instruments used in capturing the image or data.
 * @param props.currentWavelengths - Map of wavelengths to [id, start_time, end_time] currently being observed.
 * @param props.handleFindImage - Function to handle getting an image.
 * @param props.handleOpenHelioviewer - Function to handle opening the Helioviewer site.
 * @param props.handleDownload - Function to handle downloading image.
 * @param props.setWavelength - Function to set the current wavelengths.
 * @param props.setInstrument - Function to set the instrument selected.
 * @param props.setType - Function to set the type used for image processing or retrieval.
 */
export function HelioviewerModalLeftPanel(props) {
    const {
            type,
            data,
            loading,
            startTime,
            onStartTimeChange,
            imageTimestamp,
            mission,
            selection,
            helioviewerSelectionMap,
            handleFindImage,
            handleDownload,
            handleSelectionChange,
            setType} = props;

    const selectionOptionsJsx = [];
    let setOfSelection = selection && selection[0] ? new Set([selection[0]]) : new Set([]);
    setOfSelection = new Set([...setOfSelection, selection]);
    const arrOfSelection = [...setOfSelection];
    for(const selection of arrOfSelection) {
        selectionOptionsJsx.push(<option value={selection} key={selection}>{selection}</option>);
    }

    const changeToUTCTime = (localDate) => {
        const utcDate = new Date(Date.UTC(
            localDate.getFullYear(),
            localDate.getMonth(),
            localDate.getDate(),
            localDate.getHours(),
            localDate.getMinutes(),
            localDate.getSeconds()
        ));
        return utcDate;
    }

    const handleDateChange = (localDate) => {
        onStartTimeChange(changeToUTCTime(localDate));
    };

    const handleSelection = (sourceId) => {
        handleSelectionChange(sourceId);
    }

    const handleOpenVSO = () => {
        window.open(`https://sdac.virtualsolar.org/cgi/search?time=1&instrument=${selection.instrument}&version=current&build=1`);
    }

    const handleOpenHelioviewer = () => {
        let arr = [`${mission}`,`${selection.instrument}`];
        console.log(`${eTime} time `);
        let toi = startTime ? startTime.toISOString(): eTime.replace(" ","T") + "Z";
        toi = toi || new Date().toISOString();

        const visibilityOpacityArr = [1,100];
        if(selection.detector) {
            arr.push(...[`${selection.detector}`,`${selection.measurement}`]);
            arr.push(...visibilityOpacityArr);
        } else {
            arr.push(`${selection.measurement}`);
            arr.push(...visibilityOpacityArr);
        }
        window.open(`https://helioviewer.org/?imageLayers=${arr}&date=${toi}`);
    }

    const findBySourceId = (obj, targetSourceId) => {
        if (typeof obj !== 'object' || obj === null) return null;

        if (Array.isArray(obj)) {
            return obj.find(item => item?.sourceId === parseInt(targetSourceId)) || null;
        }

        for (const key in obj) {
            const result = findBySourceId(obj[key], targetSourceId);
            if (result) return result;
        }

        return null;
    };

    const  getUTCOffsetInHours = (timeZone, date = new Date()) => {
        const locale = 'en-US';
        const options = { timeZone, hour12: false, hour: '2-digit', minute: '2-digit' };
        const formatter = new Intl.DateTimeFormat(locale, options);
        const parts = formatter.formatToParts(date);
        const targetHour = parseInt(parts.find(p => p.type === 'hour')?.value || '0', 10);
        const targetMinute = parseInt(parts.find(p => p.type === 'minute')?.value || '0', 10);

        const utcHour = date.getUTCHours();
        const utcMinute = date.getUTCMinutes();

        let offsetMinutes = (targetHour - utcHour) * 60 + (targetMinute - utcMinute);
        if (offsetMinutes > 720) offsetMinutes -= 1440;
        if (offsetMinutes < -720) offsetMinutes += 1440;

        return offsetMinutes / 60;
    }


    const currentSelector = selection ? findBySourceId(helioviewerSelectionMap, selection?.sourceId) : null;
    const sTime = currentSelector ? currentSelector.start : "";
    const eTime = currentSelector ? currentSelector.end : "";
    let offsetMins, latestTimeInUTC, startTimeInUTC;

    if(currentSelector?.end) {
        let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        offsetMins = -60 * parseInt(getUTCOffsetInHours( timeZone, new Date(currentSelector?.end.replace(" ", "T") + "Z") ));
        latestTimeInUTC = new Date(new Date(currentSelector?.end.replace(" ", "T") + "Z").getTime() + offsetMins * 60000);
    }

    startTimeInUTC = startTime ? new Date(startTime.getTime() + offsetMins * 60000) : null;


     return (
               <div className="helioviewerLeftPanel">
                 <div className="helioviewerLeftPanelTop">
                   <div>
                     <div className="helioviewerDatetimeInputContainer">
                       <div className="helioviewerDatetime">
                        <div className="helioviewerFieldName"><label htmlFor="start-time">Request Time (UTC):</label></div>
                        <div className="helioviewerDateTimePicker">
                          <div><DateTimePicker
                             format= "yyyy/MM/dd HH:mm:ss"
                             id="start-time"
                             name="start-time"
                             value={  startTime
                                      ? startTimeInUTC
                                      : currentSelector?.end
                                      ? latestTimeInUTC
                                      : null}
                             clearIcon={null}
                             isCalendarOpen={false}
                             disableClock={true}
                             calendarProps={{calendarType:"gregory"}}
                             onChange={handleDateChange}
                           />
                          </div>
                          <div className="helioviewerFieldNote">
                            Start: &nbsp;&nbsp;{ sTime ? (new Date(sTime + "Z")).toISOString().replace("T", " ").split('.')[0] + " UTC" : "unknown"}
                          </div>
                          <div className="helioviewerFieldNote">
                            End:&nbsp;&nbsp;&nbsp;&nbsp; { eTime ? (new Date(eTime + "Z")).toISOString().replace("T", " ").split('.')[0] + " UTC": "unknown"}
                          </div>
                        </div>
                        <div className="helioviewerButtonContainer">
                          <button
                            className={`${"helioviewerModalFindButton"}`}
                            onClick={()=>handleFindImage()}
                            disabled={false}>{loading ?
                              <div>
                                <div className="helioviewerModalLoadingSpinner"></div>
                              </div> : "Find Image"}
                          </button>
                        </div>
                       </div>
                     </div>
                   </div>
                   <div className="helioviewerField">
                     <div className="helioviewerFieldName">Type</div>
                     <div className="helioviewerFieldValue helioviewerRadioButtonContainer">
                       <label className="helioviewerRadioButtonLabel">
                         <input
                           type="radio"
                           value={0}
                           checked={type === 0}
                           onChange={() => setType(0)}
                         />
                         <span className="helioviewerRadioButtonLabel">Color</span>
                       </label>
                       <label className="helioviewerRadioButtonLabel">
                         <input
                           type="radio"
                           value={1}
                           checked={type === 1}
                           onChange={() => setType(1)}
                         />
                         <span className="helioviewerRadioButtonLabel">Grayscale</span>
                       </label>
                     </div>
                   </div>
                   <div className="helioviewerField">
                     <div className="helioviewerFieldName">Image Timestamp</div>
                     <div className="helioviewerFieldValue">{imageTimestamp ? `${imageTimestamp.replace("T", " ").replace("Z", " ")} UTC` : "N/A"}</div>
                     <div className="helioviewerFieldValue helioviewerFieldNote">(Closest available image)</div>
                   </div>
                   <div className="helioviewerField">
                     <div className="helioviewerFieldName">Mission/Observatory</div>
                     <div className="helioviewerFieldValue">{mission}</div>
                   </div>
                   <div>
                     <div className="helioviewerInfoBox">
                       <HelioviewerMissionInfoBox mission={mission} onChange={handleSelection} defaultSourceId={selection?.sourceId}/>
                     </div>
                   </div>
                 </div>
                 <div className="helioviewerLeftPanelBottom">
                   <div className="helioviewerButtonColumnContainer">
                       <button
                         className={`helioviewerModalButtonWide`}
                         onClick={()=>handleOpenVSO()}
                         disabled={false}>Open VSO
                       </button>
                       <button
                         className={`helioviewerModalButtonWide`}
                         onClick={()=>handleOpenHelioviewer()}
                         disabled={false}>Open in Helioviewer
                       </button>
                       <button
                         className={data ? `helioviewerModalButtonWide` : `helioviewerModalButtonDisableWide`}
                         onClick={()=>handleDownload()}
                         disabled={data ? false : true}>Download Image
                       </button>
                   </div>
                 </div>
               </div>
     );
};
